import { Link as RouterLink } from 'expo-router';
import { ScrollView } from 'react-native';

import { ResponseTime } from '@/components/responseTime';
import { Avatar, AvatarFallbackText, AvatarImage } from '@/components/ui/avatar';
import { Button, ButtonText } from '@/components/ui/button';
import { Divider } from '@/components/ui/divider';
import { Heading } from '@/components/ui/heading';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';
import { ANALYTICS_EVENTS } from '@/constants/analytics';
import { ANONYMOUS_EXPERT } from '@/constants/users';
import { segmentClient } from '@/util/analytics';
import { RESPONSE_TIME_VARIES } from '@/util/userFilters';

interface AnonymousProfileViewProps {
  userId: string | number;
  expertId: string;
}

export const AnonymousProfileView = ({ userId, expertId }: AnonymousProfileViewProps) => {
  return (
    <ScrollView className="px-5" contentInsetAdjustmentBehavior="automatic">
      <VStack className="w-full items-center justify-center">
        <Avatar size="2xl" className="mb-2">
          <AvatarFallbackText>{ANONYMOUS_EXPERT.name}</AvatarFallbackText>
          <AvatarImage source={{ uri: ANONYMOUS_EXPERT.avatarSrc }} />
        </Avatar>
        <Heading size="h2-2xl" className="mb-2 text-xl">
          {ANONYMOUS_EXPERT.name}
        </Heading>
        <Text className="mb-8 text-center">{ANONYMOUS_EXPERT.focusAreaExpanded}</Text>
        <VStack className="mx-8 mb-8 w-full">
          <ResponseTime responseTimeLabel={RESPONSE_TIME_VARIES} fontSize="text-sm" />
        </VStack>
        <RouterLink
          href={{
            pathname: '/directory/inquiry/[id]',
            params: { id: userId.toString() },
          }}
          asChild>
          <Button
            onPress={() => {
              segmentClient.track(ANALYTICS_EVENTS.BIO_MESSAGE_SELECTED, {
                expert_id: expertId,
              });
            }}
            className="w-full">
            <ButtonText>Message</ButtonText>
          </Button>
        </RouterLink>
        <Divider className="my-8" />
      </VStack>
      <Text className="mb-3 text-left">{ANONYMOUS_EXPERT.preferredExpertMessage}</Text>
      <Text className="mb-1 text-left">{ANONYMOUS_EXPERT.simpleSubmissionMessage}</Text>
    </ScrollView>
  );
};
